export default __webpack_public_path__ + "static/media/david10.8cb57ac8.jpg";